/* eslint-disable max-statements */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getInfo } from './getInfo';
function Loader(props) {
  var id = props.id,
    onPrefetch = props.onPrefetch,
    loadingSpinner = props.loadingSpinner;
  useEffect(function () {
    onPrefetch === null || onPrefetch === void 0 ? void 0 : onPrefetch();
    getInfo(props);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, loadingSpinner);
}
export default Loader;
Loader.propTypes = {
  url: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  entryKey: PropTypes.string.isRequired,
  nameSpace: PropTypes.string.isRequired,
  onLoad: PropTypes.func.isRequired,
  replaceSrcMethodName: PropTypes.string.isRequired,
  onError: PropTypes.func,
  onPrefetch: PropTypes.func,
  onAssetsLoad: PropTypes.func,
  loadingSpinner: PropTypes.node
};
//# sourceMappingURL=Loader.js.map